import AntDIcon from 'antd/lib/icon'
import React from 'react'

/**
 * Octopus glyphs from Boxicons (MIT) — https://boxicons.com/icons/octopus
 * Inlined so we avoid an extra icon-library dependency.
 *
 * Boxicons only ships two octopus icons: regular (outline-style) and filled.
 */
const OLLIE_COLOURS = {
  body: '#b5d922',
  detail: '#000000',
  inverse: '#FFFFFF',
}

const OLLIE_GLYPHS = {
  regular: {
    face: 'M10 10a1 1 0 1 0 0 2a1 1 0 1 0 0-2m4 0a1 1 0 1 0 0 2a1 1 0 1 0 0-2m-5 5c0 4.92-5.76 5-6 5v2c2.77 0 8-1.46 8-7v-1H9zm6 0v-1h-2v1c0 2.88 1.42 5.02 4.11 6.17c1.92.82 3.81.83 3.89.83v-2c-.24 0-6-.08-6-5',
    body: 'M20 15c0 .55-.45 1-1 1s-1-.45-1-1c0-1.48.35-2.89.62-4.02c.07-.3.14-.59.2-.85c.23-1.06.19-2.17-.14-3.21C17.76 3.98 15.08 2 11.99 2S6.22 3.98 5.3 6.92a6.36 6.36 0 0 0-.14 3.21c.06.26.13.54.2.85c.28 1.13.62 2.54.62 4.02c0 .55-.45 1-1 1s-1-.45-1-1v-1h-2v1c0 1.65 1.35 3 3 3s3-1.35 3-3s-.38-3.26-.68-4.5c-.07-.29-.14-.56-.19-.8a4.2 4.2 0 0 1 .1-2.19C7.86 5.41 9.78 4 11.99 4s4.12 1.41 4.78 3.51c.22.71.25 1.47.1 2.19c-.05.25-.12.51-.19.8c-.3 1.24-.68 2.78-.68 4.5s1.35 3 3 3s3-1.35 3-3v-1h-2z',
  },
  filled: {
    body: 'M20 15c0 .55-.45 1-1 1s-1-.45-1-1c0-1.48.35-2.89.62-4.02c.07-.3.14-.59.2-.85c.23-1.06.18-2.17-.14-3.21a7.1 7.1 0 0 0-1.69-2.83V4h-.1c-1.28-1.25-3.01-2-4.9-2s-3.63.75-4.9 2h-.1v.09c-.76.77-1.35 1.73-1.69 2.83a6.36 6.36 0 0 0-.14 3.21c.06.26.13.54.2.85c.28 1.13.62 2.54.62 4.02c0 .55-.45 1-1 1s-1-.45-1-1v-1h-2v.66c0 .66.16 1.32.5 1.88c1.07 1.73 3.2 1.75 4.5.94c.58-.36 1.16-.64 1.75-.86C7.63 19.94 3.19 20 2.98 20v2c2.16 0 5.82-.9 7.32-3.92c.32-.65.95-1.08 1.68-1.08s1.36.44 1.68 1.09c.67 1.35 1.82 2.39 3.43 3.08c1.92.82 3.81.83 3.89.83v-2c-.21 0-4.66-.07-5.76-3.38c.59.23 1.18.5 1.76.87c1.3.81 3.43.79 4.5-.94c.35-.56.5-1.22.5-1.88v-.66h-2v1Zm-10-3c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m4 0c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1',
  },
}

/** Active Ollie glyph — switch between 'regular' and 'filled' to compare. */
const OLLIE_GLYPH = 'regular'

/**
 * Ollie mascot icon — OMS green octopus for FAB and chat header.
 *
 * @param {string|number} size - Icon dimensions (e.g. '22px', 48)
 * @param {'default'|'inverse'|'onBrand'} variant - default: OMS green; inverse: white on green buttons; onBrand: black on OMS green header
 * @param {'regular'|'filled'} glyph - Boxicons octopus style (defaults to OLLIE_GLYPH)
 */
const Icon = ({ size = '24px', variant = 'default', glyph = OLLIE_GLYPH }) => {
  const fill =
    variant === 'inverse'
      ? OLLIE_COLOURS.inverse
      : variant === 'onBrand'
      ? OLLIE_COLOURS.detail
      : OLLIE_COLOURS.body
  const paths = OLLIE_GLYPHS[glyph] || OLLIE_GLYPHS.regular

  const SVG = () => (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      role='img'
    >
      {glyph === 'filled' ? (
        <path fill={fill} d={paths.body} />
      ) : (
        <>
          <path fill={fill} d={paths.face} />
          <path fill={fill} d={paths.body} />
        </>
      )}
    </svg>
  )

  return <AntDIcon component={SVG} />
}

export default Icon
export { OLLIE_COLOURS, OLLIE_GLYPH, OLLIE_GLYPHS }
